import React, { useEffect, useState } from 'react';
import {
  useNavigate,
  useParams,
  useLocation,
  useSearchParams,
} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setQRCodeId } from 'app/state';
import { Typography, Button } from '@mui/material';
import TSButton from 'components/common/Button/Button';
import Link from '@mui/material/Link';

import { ROUTES } from 'constants/RoutePaths';
import { buildRoutePath } from 'utils/utility';

import { isUserAuth, userToken } from '_actions/user_actions';

import { signInWithRedirect } from 'aws-amplify/auth';

import { useGetTrailQuery } from 'app/api/trailApiSlice';
import MLModal from 'components/common/Modal/Modal';
import LogActivity from 'pages/Protected/Activity/LogActivity';
import WeatherForecast from 'components/TrailSafe/WeatherForecast/WeatherForecast';
import DarkFinishWarning from 'components/TrailSafe/DarkFinishWarning/DarkFinishWarning';

const TrailDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const [isAuth, setIsAuth] = useState(false);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { trailId } = useParams(); // Get trailId from URL parameters

  const QRCodeID = searchParams.get('QRCodeID');

  if (QRCodeID) {
    dispatch(setQRCodeId(QRCodeID));
  }

  useEffect(() => {
    const checkAuth = async () => {
      const t = await userToken();
      setIsAuth(!!t);
      setToken(t);
    };
    checkAuth();
    setIsLoading(false);
  }, []);

  const handleSignIn = () => {
    const path = location.pathname + location.search;
    localStorage.setItem('postSignInPath', path);
    signInWithRedirect();
  };

  const {
    data: trail,
    isLoading: isTrailLoading,
    error,
  } = useGetTrailQuery(trailId);

  if (error) {
    return (
      <div className="px-4 py-2">
        {error.status === 404 ? 'Trail not found.' : 'Error loading trail.'}
      </div>
    );
  }

  if (isLoading || isTrailLoading) {
    return <div>Loading...</div>;
  } else {
    const defaultCheckinPoint = trail[0]?.trailcheckinpoints.find(
      (point) => point.DefaultStartPoint
    );
    return (
      <>
        <div className="px-4 py-2">
          <Typography className="py-2" variant="h2">
            {trail[0]?.trailname}
          </Typography>
          <Typography className="py-2" variant="body1">
            Welcome to the home of trail {trail[0]?.trailname}, please find
            basic details below:
          </Typography>
          <ul>
            <li>Location: {trail[0]?.parkname}</li>
            <li>Distance: {trail[0]?.distancemeters} meters</li>
            <li>Duration: {trail[0]?.formattedtime}</li>
          </ul>

          <WeatherForecast trailId={trailId} />
          <DarkFinishWarning
            trailId={trailId}
            durationMinutes={trail[0]?.timeminutes}
          />

          {isAuth ? (
            <div className="flex flex-col gap-2 max-w-md">
              <TSButton
                btnText="Start Activity for this Trail"
                classList="py-4"
                onClickFunc={() => setIsModalOpen(true)}
              />
            </div>
          ) : (
            <div className="flex flex-col gap-2 max-w-md">
              <TSButton
                btnText="Sign In to start activity"
                classList="py-4"
                onClickFunc={handleSignIn}
              />
            </div>
          )}

          <div className="px-4 py-2 flex items-center">
            <img
              src={require(
                `../../../../assets/LocationImages/${trail[0].mapimagelocation}`
              )}
              alt={`Map of ${trail[0].trailname}`}
              style={{
                width: '100%',
                height: '100%',
                maxWidth: '400px',
                objectFit: 'cover',
              }}
            />
          </div>
          <Typography className="py-2" variant="body1">
            <Link
              href={trail[0]?.parksinfourl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here
            </Link>{' '}
            to go to the Tasmania Parks and Wildlife website for more
            information.
          </Typography>
        </div>
        <MLModal open={isModalOpen} setOpenModal={setIsModalOpen}>
          <LogActivity
            option={trail[0]}
            isModal={true}
            toggleModal={setIsModalOpen}
          />
        </MLModal>
      </>
    );
  }
};

export default TrailDetail;
